/**
 * Recorte de los textos largos que la tabla muestra en una sola línea
 * (regla 9, `docs/prd/PRD_R4.md:982`; CA-38).
 *
 * Por qué existe este archivo y no un `slice(0, 100)` en la fila: el PRD pide
 * que el texto visible termine en una PALABRA COMPLETA. Un `slice` crudo parte
 * «profesional» por la mitad y la fila muestra una palabra inventada. Acá se
 * corta en el último espacio antes del límite y se marca el corte con «…».
 *
 * La vista NO rearma el texto: recibe `respondio` y `lineasDeAyuda` por
 * separado (Decisión 12) y sólo recorta la respuesta.
 */

/** El límite visible de la respuesta en la tabla (regla 9: 100 caracteres). */
export const LARGO_DE_LA_RESPUESTA = 100

/**
 * Recorta `texto` a lo sumo `100` caracteres sin partir palabras: corta en el
 * último espacio anterior al límite y agrega «…» cuando hubo corte. Si el
 * texto entra completo, se devuelve tal cual (sin «…»).
 */
export function recortarEnPalabra(texto: string, limite: number = LARGO_DE_LA_RESPUESTA): string {
  const limpio = texto.trim()
  if (limpio.length <= limite) return limpio

  const corte = limpio.slice(0, limite)
  const ultimoEspacio = corte.lastIndexOf(" ")
  // Sin espacio antes del límite (una sola palabra larguísima) se corta seco
  // sobre el límite: partir más tarde no es posible y dejar el texto entero
  // desborda la celda.
  const base = ultimoEspacio > 0 ? corte.slice(0, ultimoEspacio) : corte
  return `${base.trimEnd()}…`
}
